/** Minimal session read for chrome profile menu (mirrors @unity-cosmos/auth keys). */
export const SESSION_KEY = 'unity-cosmos-session'
export const COOKIE_NAME = 'uc_session'
export const LOGIN_URL = 'https://unitycosmos.com/login'
export const RECEIPT_KEY = 'unity-cosmos-receipt'

export const LEGAL_LINKS = {
  privacy: 'https://unitycosmos.com/privacy',
  cookies: 'https://unitycosmos.com/cookies',
  terms: 'https://unitycosmos.com/terms',
  hub: 'https://unitycosmos.com',
}

export function getLegalLinks() {
  if (typeof location === 'undefined') return LEGAL_LINKS
  const host = location.hostname.toLowerCase()
  if (host === 'nightskydiary.app' || host.endsWith('.nightskydiary.app') || host.includes('nightsky-diary-v2')) {
    return {
      privacy: '/privacy-policy',
      cookies: '/cookie-policy',
      terms: '/terms-of-service',
      hub: 'https://unitycosmos.com',
    }
  }
  if (host === 'roomiehomie.com' || host.endsWith('.roomiehomie.com')) {
    return {
      privacy: '/privacy',
      cookies: '/cookies',
      terms: '/terms',
      hub: 'https://unitycosmos.com',
    }
  }
  if (host === 'unitycosmos.com' || host.endsWith('.unitycosmos.com')) {
    return {
      privacy: '/privacy',
      cookies: '/cookies',
      terms: '/terms',
      hub: '/',
    }
  }
  return LEGAL_LINKS
}

export function openLegalLink(href, event) {
  if (event) {
    event.preventDefault()
    event.stopPropagation()
  }
  if (!href || typeof window === 'undefined') return
  if (/^https?:\/\//i.test(href)) {
    window.open(href, '_blank', 'noopener,noreferrer')
    return
  }
  window.location.assign(href)
}

function isDemoSession(session) {
  if (!session) return false
  const email = String(session.email || '').toLowerCase()
  const name = String(session.name || '')
  return email === 'demo@unitycosmos.com' || /^demo unity/i.test(name) || session.demo === true
}

function isPhantomExplorer(session) {
  if (!session) return false
  const email = String(session.email || '').toLowerCase()
  const name = String(session.name || '')
  return email === 'user@unitycosmos.com' || name === 'Cosmos Explorer'
}

function shouldRejectDemo() {
  if (typeof location === 'undefined') return true
  const h = location.hostname
  return h !== 'localhost' && h !== '127.0.0.1'
}

function readCookieSession() {
  if (typeof document === 'undefined') return null
  const prefix = `${COOKIE_NAME}=`
  const hit = document.cookie.split('; ').find((row) => row.startsWith(prefix))
  if (!hit) return null
  try {
    const session = JSON.parse(decodeURIComponent(hit.slice(prefix.length)))
    if (session?.expiresAt && Date.now() > session.expiresAt) return null
    if (!session?.active) return null
    if (shouldRejectDemo() && isDemoSession(session)) return null
    if (isPhantomExplorer(session)) return null
    return session
  } catch {
    return null
  }
}

export function readChromeSession() {
  if (typeof localStorage === 'undefined') return null
  try {
    const raw = localStorage.getItem(SESSION_KEY)
    if (raw) {
      const session = JSON.parse(raw)
      if (session?.expiresAt && Date.now() > session.expiresAt) {
        clearChromeSession()
        return null
      }
      if (session?.active) {
        if ((shouldRejectDemo() && isDemoSession(session)) || isPhantomExplorer(session)) {
          clearChromeSession()
          return null
        }
        return session
      }
    }
  } catch {
    /* ignore */
  }
  return readCookieSession()
}

export function clearChromeSession() {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(SESSION_KEY)
    localStorage.removeItem(RECEIPT_KEY)
  }
  if (typeof document === 'undefined') return
  const domain =
    typeof location !== 'undefined' && location.hostname.endsWith('unitycosmos.com')
      ? '; domain=.unitycosmos.com'
      : ''
  document.cookie = `${COOKIE_NAME}=; path=/; max-age=0${domain}`
  document.cookie = `${RECEIPT_KEY}=; path=/; max-age=0${domain}`
  try {
    new BroadcastChannel('unity-cosmos-auth').postMessage({ action: 'logout' })
  } catch {
    /* ignore */
  }
}

export function loginHref(returnUrl) {
  const base = typeof window !== 'undefined' ? window.location.href.split('?')[0] : '/'
  const ret = returnUrl || base
  return `${LOGIN_URL}?return=${encodeURIComponent(ret)}&reauth=1`
}
